import React, { type SyntheticEvent, useState } from 'react';

import { useGetIFS } from '../hooks/tanstack/useIFSHook';
import { useGetRouteParams } from '../hooks/tanstack/useUtilsHook';

import IFSTableSection from './dataset/IFSTableSection';
import IFSViewFilesDataTable from './dataset/IFSViewFilesDataTable';
import { CustomTabPanel, Tab, Tabs } from './mui-custom';

const TABS = ['Import', 'View Data'];

const UploadIFSFilesTabs = () => {
  const [index, setIndex] = useState(0);

  const { orgId, projectId, datasetId } = useGetRouteParams();

  const { data: ifs } = useGetIFS(
    {
      orgId,
      projectId,
      datasetId,
    },
    {
      enabled: !!datasetId && !!projectId && !!orgId,
    }
  );

  const isDisabled =
    ifs?.files.filter((file) => !file.is_imported).length === ifs?.files.length;

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setIndex(newValue);
  };

  return (
    <div className="flex flex-col gap-4">
      <Tabs value={index} onChange={handleChange}>
        {TABS.map((report) => (
          <Tab
            id={report}
            key={report}
            label={report}
            disabled={report === 'View Data' && !!isDisabled}
          />
        ))}
      </Tabs>
      <CustomTabPanel value={index.toString()} index="0">
        <IFSTableSection />
      </CustomTabPanel>
      <CustomTabPanel value={index.toString()} index="1">
        <IFSViewFilesDataTable />
      </CustomTabPanel>
    </div>
  );
};

export default UploadIFSFilesTabs;
